import { motion } from "framer-motion";

const planes = [
  {
    image: "/pagina-simple.png",
    title: "💻 Página Web Simple",
    desc: [
      "✔️ Hasta 5 secciones",
      "✔️ Diseño adaptable a móviles",
      "🎁 1 mes de hosting gratis",
      "🌐 Dominio .cl o .com por 1 año",
      "📬 Formulario de contacto",
      "🔒 SSL (https) incluido",
      "📈 SEO básico",
    ],
    precioAntes: "$180.000",
    precioOferta: "$130.000",
  },
  {
    image: "/tienda-online.png",
    title: "🛒 Tienda Ecommerce",
    desc: [
      "🛍️ Catálogo hasta 20 productos",
      "💳 Carrito + botón de pago",
      "📦 Panel para pedidos y productos",
      "📱 Diseño responsive",
      "🌐 Dominio + hosting 1 mes",
      "💬 Integración con WhatsApp",
      "🎓 Capacitación básica",
    ],
    precioAntes: "$300.000",
    precioOferta: "$220.000",
  },
  {
    image: "/desarrollo-a-medida.png",
    title: "🛠️ Software a Medida",
    desc: [
      "🔍 Análisis de requerimientos",
      "📐 Funcionalidades personalizadas",
      "🗃️ Base de datos a medida",
      "📊 Panel de administración",
      "🔗 Integración con APIs",
      "📘 Documentación y soporte",
      "💬 Acompañamiento técnico",
    ],
    precioAntes: "desde $500.000",
    precioOferta: "desde $400.000",
  },
];

function PlansSection({ id }) {
  return (
    <section id={id} className="py-20 px-4 sm:px-6 lg:px-12 bg-background">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <motion.h2
          className="text-4xl md:text-5xl font-bold text-white font-anton uppercase"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Nuestros Servicios
        </motion.h2>
        <motion.p
          className="mt-4 text-gray-300 text-lg max-w-2xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          viewport={{ once: true }}
        >
          Elige el servicio perfecto para ti y potencia tu negocio con
          soluciones digitales a medida.
        </motion.p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl mx-auto">
        {planes.map((plan, idx) => (
          <motion.div
            key={idx}
            className="flex flex-col rounded-3xl shadow-xl overflow-hidden bg-white transition-all duration-300"
            whileHover={{
              scale: 1.05, // Aumenta el tamaño de la tarjeta al hacer hover
              translateY: "-10px", // Mueve la tarjeta ligeramente hacia arriba
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)", // Sombra más grande al hacer hover
            }}
            transition={{ duration: 0.15 }}
          >
            {/* Imagen */}
            <div className="relative w-full aspect-[4/3]">
              <img
                src={plan.image}
                alt={plan.title}
                className="absolute inset-0 w-full h-full object-cover rounded-t-3xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-t-3xl" />
            </div>

            {/* Contenido */}
            <div className="p-6 text-center flex flex-col flex-grow">
              <h3 className="text-2xl font-bold text-indigo-600 mb-2">
                {plan.title}
              </h3>
              <ul className="text-sm text-gray-600 text-left space-y-1">
                {plan.desc.map((item, i) => (
                  <li
                    key={i}
                    className="before:content-['•'] before:mr-2 before:text-accent"
                  >
                    {item}
                  </li>
                ))}
              </ul>

              <div className="mt-auto">
                <div className="flex flex-col items-center mt-4">
                  <span className="text-sm text-gray-400 line-through">
                    {plan.precioAntes}
                  </span>
                  <span className="text-2xl font-bold text-black">
                    {plan.precioOferta}
                  </span>
                  <a href="#contacto">
                    <button className="bg-black hover:bg-indigo-700 text-white font-semibold py-2 px-5 rounded-lg shadow-md transition-transform hover:scale-105">
                      Solicitar
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}

export default PlansSection;
